import React from 'react';
import { motion } from 'framer-motion';

function DifferentiatorsSection() {
  const differentiatorsData = [
    {
      title: "Focus on Investment Opportunities and Performance",
      subtitle: "Strategic Market Intelligence",
      description: "By combining the depth of our expertise with the breadth of our platform, we aim to identify market opportunities and provide innovative solutions to help our clients reach their unique investment objectives.",
      image: "/new-assets/pexels-mart-production-7222273.jpg",
      features: [
        "Deep market analysis and research",
        "Customized investment strategies", 
        "Risk-adjusted return optimization",
        "Performance monitoring and reporting"
      ]
    },
    {
      title: "Knowledge Transfer Across Leading Institutions",
      subtitle: "Institutional Expertise",
      description: "We help sovereign institutions navigate shifting dynamics that impact both their existing asset allocations and long-term investment strategies.",
      image: "/new-assets/pexels-mart-production-7255275.jpg",
      features: [
        "Sovereign wealth management",
        "Institutional asset allocation",
        "Regulatory compliance guidance",
        "Long-term strategic planning"
      ]
    },
    {
      title: "Access to Global Thought Leaders",
      subtitle: "Network Advantage",
      description: "Our global network and longstanding relationships allow us to identify relevant market trends and provide thoughtful, timely and innovative solutions.",
      image: "/new-assets/pexels-mart-production-7709127.jpg",
      features: [
        "Global market insights",
        "Industry thought leadership",
        "Innovative solution development",
        "Timely market intelligence"
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-semibold text-gray-900 mb-4">What Sets Us Apart</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
            Our unique approach combines institutional expertise with innovative solutions
          </p>
        </div>

        <div className="space-y-20">
          {differentiatorsData.map((item, index) => (
            <div
              key={item.title}
              data-aos="fade-up"
              data-aos-delay={`${200 + index * 200}`}
              className={`flex flex-col lg:flex-row items-center gap-12 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className="flex-1">
                <div className="w-12 h-12 rounded-full bg-[#0056d7] flex items-center justify-center shadow-md mb-6">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white">
                    <path d="M3 3v18h18" />
                    <path d="M7 15l4-4 3 3 4-6" />
                  </svg>
                </div>
                <h3 className="text-3xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-lg text-[#0056d7] font-medium mb-6">{item.subtitle}</p>
                <p className="text-lg text-gray-600 leading-relaxed mb-8 text-left">{item.description}</p>
                
                <ul className="space-y-3">
                  {item.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-[#0056d7] rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="flex-1 w-full max-w-2xl mx-auto lg:mx-0">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-auto lg:h-80 object-cover rounded-2xl shadow-lg transition-transform duration-700 hover:scale-105"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DifferentiatorsSection;
